import _, { escape } from "lodash";
import React, { useState } from "react";
import Constants, {
  leadScoringActivity,
  userActivity,
} from "../../../../common/constants";
import { Mixpanel } from "../../../../config/Mixpanel";
import { createLeadScore } from "../../../../redux/actions/pricing";
import { addUserActivity } from "../../../../redux/actions/profileDetails";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const StickyButton = ({
  activeChildProduct,
  activeChildButton,
  activeCard,
  razorpayHandler,
  setDowngradeModal,
  setIsCheckModal,
  proData,
  maxData,
  defaultSticky
}) => {
  const [spinner1, setSpinner1] = useState(false);

  const isBlocked = useSelector(
    (store) => store?.userActivity?.user_trial_blocked
  );
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const email = useSelector((store) => store?.profileDetails?.email);
  const dispatch = useDispatch();
  const isEligible = useSelector(
    (store) => store?.userSubscription?.isEligibleForLearntubeMax
  );
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const navigate = useNavigate();
  function getRandomArbitary() {
    
    const d = new Date();
    let day = d.getDay();

    if(day === 0)
    return 1;
    else
    return 8 - day
  

  }

  function createLeadsForCards() {
    dispatch(
      addUserActivity(user_id, userActivity.PAYMENT_ATTEMPT, "", false, null)
    );
    switch (activeCard?.plan_name) {
      case "LearnTube Pro":
        // eslint-disable-next-line no-lone-blocks
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTPRO.type)
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPRO, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Pro+":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTPROPLUS.type)
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTPROPLUS, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTubeX":
        {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.CLICKED_LTX.type)
          );
          Mixpanel.track(Constants.Mixpanel.CLICKED_LTX, {
            distinct_id: email,
          });
        }
        break;
      case "LearnTube Max": {
        dispatch(
          createLeadScore(user_id, leadScoringActivity.CLICKED_LTMAX.type)
        );
        Mixpanel.track(Constants.Mixpanel.CLICKED_LTMAX, {
          distinct_id: email,
        });
      }
      default:
        break;
    }
  }
  function firstButtonClick(e) {
    console.log('clicked')
    if(user_id === 0 || user_id === null || user_id === undefined){
      navigate('/login');
      return;
    }

   if ((activeCard?.plan_name === "LearnTube Max" || !activeChildProduct?.product_name) && !isEligible  && user_role !== 7) {
      setIsCheckModal(true);
    } else if (activeCard?.plan_name === "Downgrade" && isBlocked) {
      setDowngradeModal(true);
    } else {
      setSpinner1(true);
      if(!activeChildProduct?.product_name){
        razorpayHandler(17, () =>
        setSpinner1(false)
      );
      }
      else{
      razorpayHandler(activeChildProduct?.products_id, () =>
        setSpinner1(false)
      );
      }
    }
  }

  const spinner = () => {
    return (
      <div
        className={`h-8 w-8 rounded-full border-4 border-[${activeCard?.plan_color_primary}] animate-spin border-t-transparent`}
      ></div>
    );
  };

  console.log('button' , defaultSticky)
  if (
    activeChildProduct?.product_name === "LearnTube Pro" ||
    activeChildProduct?.product_name === "LearnTubeX"
  ) {
    return (
      <>
        <button
          className="w-full flex  flex-col items-center justify-center font-medium rounded-lg py-2 text-sm text-white md:text-black md:bg-white"
          style={{
            background:
            window.innerWidth <768 &&
              activeChildButton?.first?.button_type === "gradient" &&
              `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
          }}
          onClick={(e) => {
            firstButtonClick(e);
            createLeadsForCards();
          }}
        >
          
          {spinner1
              ? spinner()
              : activeChildButton?.first?.button_primary_text}
        </button>
        <div className="text-xs font-medium mt-1 md:text-white">
          ₹{activeChildProduct?.cost_details?.final_cost_total} for{" "}
          {activeChildProduct?.product_tab_heading}
        </div>
      </>
    );
  } else if (activeChildProduct?.product_name === "LearnTube Max") {
    if (
        !isEligible
    ) {
      return (
        <>
          <button
            className=" flex w-full flex-col text-sm items-center justify-center font-medium rounded-lg py-2 text-white md:text-black md:bg-white"
            style={{
             
              background:
              window.innerWidth <768 && 
                activeChildButton?.first?.button_type === "gradient" &&
                `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
            }}
            onClick={(e) => {
              firstButtonClick(e);
              createLeadsForCards();
            }}
          >
            {spinner1
              ? spinner()
              : activeChildButton?.first?.button_primary_text}
          </button>
          <div className="text-[10px] font-medium mt-1 md:text-white">
                  Only {getRandomArbitary()} Seats Remaining
                </div>
        </>
      );
    } 
    else {
      return (
        <>
          <button
            className=" flex w-full flex-col items-center justify-center font-medium rounded-lg py-1 text-white md:text-black md:bg-white"
            style={{ 
              background:
              window.innerWidth <768 && 
                activeChildButton?.first?.button_type === "gradient" &&
                `linear-gradient(418deg, ${activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_color_secondary} 86.12%)`,
            }}
            onClick={(e) => {
              firstButtonClick(e);
              createLeadsForCards();
            }}
          >
            {spinner1 ? (
              spinner()
            ) : (
              <>
                <div className="text-sm">
                  {activeChildButton?.first?.button_primary_text}
                </div>
              </>
            )}
          </button>
          <div className="text-xs font-medium mt-1 md:text-white">
          ₹{activeChildProduct?.cost_details?.final_cost_total} for{" "}
          {activeChildProduct?.product_tab_heading}
        </div>
                            
        </>
      );
    } 
}
else if(!activeChildProduct?.product_name){
  if (
    !isEligible
) {
  return (
    <>
      <button
        className=" flex w-full flex-col text-sm items-center justify-center font-medium rounded-lg py-2 text-white md:text-black md:bg-white"
        style={{
         
          background:
          window.innerWidth <768 && 
            defaultSticky?.first?.button_type === "gradient" &&
            `linear-gradient(418deg, ${maxData?.plan_color_primary} 16.15%, ${maxData?.plan_color_secondary} 86.12%)`,
        }}
        onClick={(e) => {
          firstButtonClick(e);
          createLeadsForCards();
        }}
      >
        {spinner1
          ? spinner()
          : defaultSticky?.first?.button_primary_text}
      </button>
      <div className="text-[10px] font-medium mt-1 md:text-white">
              Only {getRandomArbitary()} Seats Remaining
            </div>
    </>
  );
} 
else {
  return (
    <>
      <button
        className=" flex w-full flex-col items-center justify-center font-medium rounded-lg py-1 text-white md:text-black md:bg-white"
        style={{ 
          background:
          window.innerWidth <768 && 
            defaultSticky?.first?.button_type === "gradient" &&
            `linear-gradient(418deg, ${maxData?.plan_color_primary} 16.15%, ${maxData?.plan_color_secondary} 86.12%)`,
        }}
        onClick={(e) => {
          firstButtonClick(e);
          createLeadsForCards();
        }}
      >
        {spinner1 ? (
          spinner()
        ) : (
          <>
            <div className="text-sm">
              {defaultSticky?.first?.button_primary_text}
            </div>
          </>
        )}
      </button>
      <div className="text-xs font-medium mt-1 md:text-white">
      ₹{maxData?.plan_products?.[0]?.cost_details?.final_cost_total} for{" "}
      {maxData?.plan_products?.[0]?.product_tab_heading}
    </div>
                        
    </>
  );
} 

}
  else{
    return ( <><button
        className=" flex w-full flex-col items-center justify-center font-medium rounded-lg py-1 text-white md:text-black md:bg-white"
        style={{ 
          background:
          window.innerWidth <768 && 
            `linear-gradient(418deg, ${proData?.plan_color_primary} 16.15%, ${proData?.plan_color_secondary} 86.12%)`,
        }}
        onClick={(e) => {
          if(user_id === 0 || user_id === null || user_id === undefined){
            navigate('/login');
            return;
          }
            dispatch(
                addUserActivity(user_id, userActivity.PAYMENT_ATTEMPT, "", false, null)
              );
              dispatch(
                createLeadScore(user_id, leadScoringActivity.CLICKED_LTPRO.type)
              );
              Mixpanel.track(Constants.Mixpanel.CLICKED_LTPRO, {
                distinct_id: email,
              });
              setSpinner1(true);
              razorpayHandler(proData?.plan_products?.[2]?.products_id, () =>
                setSpinner1(false)
              );

        }}
      >
        {spinner1 ? (
          spinner()
        ) : (
          <>
            <div className="text-sm">
              {proData?.plan_button_states?.[0]?.state_buttons?.[0]?.button_primary_text}
            </div>
          </>
        )}
      </button>
      <div className="text-xs font-medium mt-1 md:text-white">
      ₹{proData?.plan_products?.[2]?.cost_details?.final_cost_total} for{" "}
      {proData?.plan_products?.[2]?.product_tab_heading}
    </div>
    </>)
  }
};

export default StickyButton;
